import { useId } from 'react';
import { cx } from '../lib/cx';

export function LogoMark({ className }: { className?: string }) {
  const gradient = useId();
  return (
    <svg viewBox="0 0 64 64" className={cx('size-9', className)} aria-hidden>
      <defs>
        <linearGradient id={gradient} x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#ef6a3d" />
          <stop offset="1" stopColor="#c7361f" />
        </linearGradient>
      </defs>
      <rect width="64" height="64" rx="16" fill={`url(#${gradient})`} />
      <path
        d="M25 13c-3 3 3 6 0 9M32 11c-3 3 3 6 0 9M39 13c-3 3 3 6 0 9"
        fill="none"
        stroke="#fff"
        strokeWidth="3"
        strokeLinecap="round"
        opacity="0.85"
      />
      <path d="M11 30h42c0 11.6-9.4 21-21 21S11 41.6 11 30z" fill="#fff" />
      <path d="M22 51h20" stroke="#fff" strokeWidth="4" strokeLinecap="round" />
    </svg>
  );
}
